export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10866.81e673e3.jpg";